import { useRecoilValue } from 'recoil';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
import { getVSGAPhoto } from '~/lib/api/documents/getVSGAPhoto';
import { damagePhotoUploadURLUniqueKeySelectorFamily } from '~/state';

export const useGetDamageBlob = (id: string) => {
  const { t } = useTranslation();
  const damage = useRecoilValue(
    damagePhotoUploadURLUniqueKeySelectorFamily({ id })
  );

  const { fileId, documentId } = damage;

  return useApiQuery({
    request: getVSGAPhoto,
    params: {
      vars: {
        documentId: documentId ?? '',
        fileId: fileId ?? '',
      },
    },
    options: {
      errorText: t('document.errors.loadDocument'),
    },
    queryKey: [id, fileId, documentId],
    queryOptions: {
      enabled: !!documentId && !!fileId,
    },
  });
};
